import { Action } from "@ngrx/store";
import { Location } from '../../../shared/models/location.model';

export const GET_LOCATIONS_LIST = '[Groups] Get Campus Locations List';
export const GET_LOCATIONS_LIST_SUCCESS = '[Groups] Get Campus Locations List Success';
export const GET_LOCATIONS_LIST_FAIL = '[Groups] Get Campus Locations List Fail';

export class GetLocationsList implements Action {
  readonly type = GET_LOCATIONS_LIST;
  constructor(public payload: { institutionId: number } = null) { }
}

export class GetLocationsListSuccess implements Action {
  readonly type = GET_LOCATIONS_LIST_SUCCESS;
  constructor(public payload: Location) { }
}

export class GetLocationsListFail implements Action {
  readonly type = GET_LOCATIONS_LIST_FAIL;
  constructor(public payload: any = null) { }
}

export type LocationsActions =
  | GetLocationsList
  | GetLocationsListSuccess
  | GetLocationsListFail
  ;